import { env } from "./configEnv/env";

// ------------------------------- CONSTANTS -------------------------------
export const DEFAULT_HEADER_GROUP_ID = "id-grupo";
export const DEFAULT_COMPANY_HEADER = "empresa-acesso";
export const DEFAULT_SPACE_USERNAME = env.VITE_SPACE_USERNAME;
export const DEFAULT_FONT_SANS = '"Saira", Arial, sans-serif';
export const DEFAULT_FONT_MONO = '"DM Mono", "Fira Code", "SFMono-Regular", Menlo, Consolas, monospace';

export const MIN_CARACTERES_LOOKUP_USUARIO = 3;

export const CONFIGURACAO_USERTOUR = {
	WS_URI: "https://usertour.spacesrv.com.br/",
	ASSETS_URI: "https://usertour.spacesrv.com.br/sdk",
	USERTOURJS_ES2020_URL: "https://usertour.spacesrv.com.br/sdk/es2020/usertour.js",
	USERTOURJS_LEGACY_URL: "https://usertour.spacesrv.com.br/sdk/legacy/usertour.iife.js",
} satisfies NonNullable<Window["USERTOURJS_ENV_VARS"]>;
